import { Autocomplete, TextField } from "@mui/material";
import buildUrl from "build-url-ts";
import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import { parentFaultsOptions, ParentViewsOption, parentViewsOptions } from "../../constants/parentFault";
import ControlsBar from "../common/ControlsBar";
import MultiSelect from "../common/MultiSelect";
import { styled } from "@mui/system";
import LocalStorageContext from "../../contexts/LocalStorageContext";

const ImageContainer = styled("div")({
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap",
});

const Image = styled("img")({
  padding: "5px",
  maxHeight: "80vh",
  width: "25%",
  objectFit: "contain",
  flexGrow: 2,
  flexShrink: 3,
});

interface ParentFaultViewProps {
  id: string;
  setDisableHotkey: Dispatch<SetStateAction<boolean>>;
}

const ParentFaultView: React.FC<ParentFaultViewProps> = ({ id, setDisableHotkey }: ParentFaultViewProps) => {
  const { parentFaultViews, setParentFaultViews, parentFault, setParentFault } = useContext(LocalStorageContext);

  const [viewsSelections, setViewsSelections] = useState<ParentViewsOption[]>([parentViewsOptions[0]]);
  const [inputValue, setInputValue] = React.useState("");

  const viewsOptions: string[] = [];
  parentViewsOptions.map((view) => {
    viewsOptions.push(view.displayName);
  });

  useEffect(() => {
    const filtered = parentViewsOptions.filter((option) => {
      return parentFaultViews.includes(option.displayName);
    });
    setViewsSelections(filtered);
  }, [parentFaultViews]);

  const getUrl = (path: string) => {
    return buildUrl(import.meta.env.VITE_REPORTS_URL, {
      path: `/${id}/solution_report/parent_sect_pages/${parentFault}/resources${path}`,
    });
  };

  return (
    <>
      <ControlsBar>
        <MultiSelect name="Views" selected={parentFaultViews} options={viewsOptions} setOptions={setParentFaultViews} />
        <Autocomplete
          value={parentFault}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onChange={(_event: any, newValue: string | null) => {
            setParentFault(newValue as string);
          }}
          inputValue={inputValue}
          onInputChange={(_event, newInputValue) => {
            setInputValue(newInputValue);
          }}
          id="controllable-states-demo"
          options={parentFaultsOptions}
          style={{ width: 300 }}
          renderInput={(params) => <TextField {...params} label="Parent Faults" />}
          onOpen={() => setDisableHotkey(true)}
          onClose={() => setDisableHotkey(false)}
        />
      </ControlsBar>
      <ImageContainer>
        {parentFault
          ? viewsSelections.map((option, i) => (
              <Image key={option.path + i} src={getUrl(option.path)} alt={option.path} />
            ))
          : "Select a parent fault to display charts."}
      </ImageContainer>
    </>
  );
};

export default ParentFaultView;
